import {
  getAllMarketplaceAssetsQuery,
  getFavoriteMarketplaceAssetsQuery,
  getNewlyAddedMarketplaceAssetsQuery,
  getTopTenMarketplaceAssetsQuery,
} from 'src/gql';

export enum CoinFilters {
  ALL = 'ALL',
  FAVORITES = 'FAVORITES',
  TOPTEN = 'TOPTEN',
  NEW = 'NEW',
}

export const COIN_FILTERS = [
  CoinFilters.ALL,
  CoinFilters.FAVORITES,
  CoinFilters.TOPTEN,
  CoinFilters.NEW,
];

export const COIN_LIST_QUERIES = {
  [CoinFilters.ALL]: getAllMarketplaceAssetsQuery,
  [CoinFilters.FAVORITES]: getFavoriteMarketplaceAssetsQuery,
  [CoinFilters.TOPTEN]: getTopTenMarketplaceAssetsQuery,
  [CoinFilters.NEW]: getNewlyAddedMarketplaceAssetsQuery,
};

export const COIN_TEXTS = {
  [CoinFilters.ALL]: 'withdraw_all_assets',
  [CoinFilters.FAVORITES]: 'common_favorites',
  [CoinFilters.TOPTEN]: 'common_top_ten',
  [CoinFilters.NEW]: 'common_newly_added_coins',
};
